import _ from 'lodash';
import TWIADateUtil from './TWIADateUtil';

const DATE1998Sep01 = new Date('1998-09-01');
const DATE2003Feb01 = new Date('2003-02-01');
const DATE2003Jun01 = new Date('2003-06-01');
const DATE2020Sep01 = new Date('2020-09-01');

export default class TWIAHoConstructionUtil {


    /**
     * Filter available Building Code Class options based on the Original Construction Date
     * @param availableBuildingCodeClasses
     * @param originalConstructionLocalDate
     */
    static filterBuildingCodeClassesTWIA(availableBuildingCodeClasses, originalConstructionLocalDate, hasWPI8Issued, hasRetrofitIssued) {
        // Construct available list based on the Original Construction Date
        if (originalConstructionLocalDate) {
            const originalConstructionDate = TWIADateUtil.localDateToDate(originalConstructionLocalDate)
            if (originalConstructionDate >= DATE2020Sep01
                || originalConstructionDate < DATE1998Sep01
                || !hasWPI8Issued) {
                _.remove(availableBuildingCodeClasses, { code: 'seaward' });
                _.remove(availableBuildingCodeClasses, { code: 'inlandI' });
            }
            if (originalConstructionDate >= DATE2020Sep01
                || originalConstructionDate < DATE2003Feb01
                || !hasWPI8Issued) {
                _.remove(availableBuildingCodeClasses, { code: 'inlandII' });
            }
            if (originalConstructionDate >= DATE2003Feb01
                || !hasRetrofitIssued) {
                _.remove(availableBuildingCodeClasses, { code: 'retrofit' });
            }
            if (originalConstructionDate < DATE2020Sep01
                || !hasWPI8Issued) {
                _.remove(availableBuildingCodeClasses, { code: 'riskcat1' });
                _.remove(availableBuildingCodeClasses, { code: 'riskcat2' });
                _.remove(availableBuildingCodeClasses, { code: 'riskcat4' });
            }
        }
        return availableBuildingCodeClasses;
    }

    /**
     * Filter available Building Code options based on the Building Code Class and Original Construction Date
     * @param availableBuildingCodes
     * @param buildingCodeClass
     * @param originalConstructionLocalDate
     * @returns {*}
     */
    static filterBuildingCodesTWIA(availableBuildingCodes, buildingCodeClass, originalConstructionLocalDate) {
        // Construct available list based on the Original Construction Date and Building Code Class
        if (originalConstructionLocalDate && buildingCodeClass) {
            const originalConstructionDate = TWIADateUtil.localDateToDate(originalConstructionLocalDate)
            if (buildingCodeClass.code === 'seaward'
                || buildingCodeClass.code === 'inlandI'
                || buildingCodeClass.code === 'inlandII') {
                if (originalConstructionDate < DATE2003Feb01) {
                    _.remove(availableBuildingCodes, { code: 'ircoribc' });
                }
            } else if (buildingCodeClass.code === 'retrofit') {
                if (originalConstructionDate < DATE1998Sep01
                    || originalConstructionDate >= DATE2003Feb01) {
                    _.remove(availableBuildingCodes, { code: 'ircoribc' });
                }
            }
            if (buildingCodeClass.code === 'seaward'
                || buildingCodeClass.code === 'inlandI') {
                if (originalConstructionDate < DATE1998Sep01
                    || originalConstructionDate >= DATE2003Jun01) {
                    _.remove(availableBuildingCodes, { code: 'wrc' });
                }
            } else if (buildingCodeClass.code === 'retrofit') {
                if (originalConstructionDate >= DATE1998Sep01) {
                    _.remove(availableBuildingCodes, { code: 'wrc' });
                }
            }
        }
        return availableBuildingCodes;
    }
}
